// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__23tFC","question":"Question_question__3-K2P","description":"Question_description__r34ne"};